/**
 * @generated SignedSource<<ab2ba5e162f96b7ab168d9377f04934d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sharedMessageHelpers_expiringPromotion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"expiringPromoMessageHelpers_expiringPromotion">;
  readonly " $fragmentType": "sharedMessageHelpers_expiringPromotion";
};
export type sharedMessageHelpers_expiringPromotion$key = {
  readonly " $data"?: sharedMessageHelpers_expiringPromotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"sharedMessageHelpers_expiringPromotion">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sharedMessageHelpers_expiringPromotion"
};

(node as any).hash = "925f9835008643739f14499a6546d9b2";

export default node;
